// @flow

import { openDialog } from '../../../../../react/features/base/dialog/actions';
import { translate } from '../../../../../react/features/base/i18n/functions';
import {
    getLocalParticipant,
    isParticipantModerator
} from '../../../../../react/features/base/participants/functions';
import AbstractButton, { IProps as AbstractButtonProps } from '../../../../../react/features/base/toolbox/components/AbstractButton';
import { connect } from 'react-redux';
import { IconRecordingList } from '../../../../components/base/icons/svg';

import RecordingsList from './RecordingsList';


/**
 * The type of the React {@code Component} props of {@link VideoBlurButton}.
 */
type IProps = AbstractButtonProps & {

    /**
     * The Redux dispatch function.
     */
    dispatch: Function,

    /*
       ** Whether the local participant is a moderator or not.
       */
    isModerator: Boolean,

    /**
     * The ID of the local participant.
     */
    localParticipantId: string

};

/**
 * An abstract implementation of a button that toggles the video blur effect.
 */
class RecordingsListButton extends AbstractButton<IProps, *> {
    accessibilityLabel = 'button.viewRecordings';
    icon = IconRecordingList;
    label = 'button.viewRecordings';

    /**
     * Handles clicking / pressing the button, and toggles the blur effect
     * state accordingly.
     *
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;

        dispatch(openDialog(RecordingsList));
    }
}

/**
 * Maps part of the redux state to the component's props.
 *
 * @param {Object} state - The redux store/state.
 * @param {Props} ownProps - The component's own props.
 * @returns {Object}
 */
function _mapStateToProps(state: Object) {
    const localParticipant = getLocalParticipant(state);
    const isModerator = isParticipantModerator(localParticipant);

    return {
        isModerator,
        localParticipantId: localParticipant.id,
        visible: isModerator
    };
}

export default translate(connect(_mapStateToProps)(RecordingsListButton));
